import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import debounce from "lodash.debounce";
import { TableWrapper, ClaimResolutioHeader, ResolutionModalInnerBoxes, ClaimContainer } from './ClaimStyled'
import { SearchWrapper } from '../DashBoard/dashBoardStyled';
import { AiOutlineSearch } from "react-icons/ai";
import Spinner from '../../../../components/Spinner'
import { adminClaimList, adminResolvedClaimList, adminClaimResolve, adminRefundResolve, reverseSellerPayoutApi, adminCompletedOrderListforRefund, adminRefundCompletedTrans } from '../../../../../redux/actions/admin';
import ClaimDetails from './ClaimDetails';
import Refunds from './Refunds';
import { Heading } from 'web/pages/private/Admin/adminStyled'
import AlertModal from 'web/components/AlertModal';
import ResolutionModal from './ResolutionModal';
import AdjustmentModal from './AdjustmentModal';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import CloseIcon from "web/assets/images/CloseIcon.png";
import * as moment from 'moment';

function Claim({ scrollTop }) {
  const dispatch = useDispatch()
  let history = useHistory()
  const loaderVisible = useSelector(state => state.appReducer.loaderVisible);
  const adminRoles = useSelector(state => state.admin.adminRoles)

  // data store for each tab
  const [pendingClaimsDataList, setPendingClaimsDataList] = useState()
  const [resolvedClaimsDataList, setResolvedClaimsDataList] = useState()
  const [refundTabDataList, setRefundTabDataList] = useState()
  const [refundedTransactionsTabDataList, setRefundedTransactionsTabDataList] = useState()

  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [selectedTab, setSelectedTab] = useState('pendingClaims')

  const [claimResolutionModal, setClaimResolutionModal] = useState(false)
  const [claimResolutionConfirmationModal, setClaimResolutionConfirmationModal] = useState(false)
  const [refundAdjustmentModal, setRefundAdjustmentModal] = useState(false)
  const [refundConfirmationModal, setRefundConfirmationModal] = useState(false)

  const [claimResolutionType, setClaimResolutionType] = useState(false)
  const [refundProcessType, setRefundProcessType] = useState(false)
  const [clickedOrderDetails, setClickedOrderDetails] = useState()
  const [resolvePayload, setResolvePayload] = useState()
  const [searchText, setSearchText] = useState('')

  // page no. store set for each tabs in order
  const [pageNumberPendingClaim, setPageNumberPendingClaim] = useState(1)
  const [pagesCountPendingClaim, setPagesCountPendingClaim] = useState(0);
  const [totalDataPendingClaim, setTotalDataPendingClaim] = useState(0);

  const [pageNumberResolvedClaim, setPageNumberResolvedClaim] = useState(1)
  const [pagesCountResolvedClaim, setPagesCountResolvedClaim] = useState(0);
  const [totalDataResolvedClaim, setTotalDataResolvedClaim] = useState(0);

  const [pageNumberRefundTab, setPageNumberRefundTab] = useState(1)
  const [pagesCountRefundTab, setPagesCountRefundTab] = useState(0);
  const [totalDataRefundTab, setTotalDataRefundTab] = useState(0);

  const [pageNumberRefundedTransTab, setPageNumberRefundedTransTab] = useState(1)
  const [pagesCountRefundedTransTab, setPagesCountRefundedTransTab] = useState(0);
  const [totalDataRefundedTransTab, setTotalDataRefundedTransTab] = useState(0);

  // state to handle expand and collapse div in claimDetails component(1,2 tab)
  const [expandPanel, setExpandPanel] = useState()

  // state to handle expand and collapse div in refunds component(3,4 tab)
  const [expandPanelRefund, setExpandPanelRefund] = useState()

  let fromDate = new Date();
  let toDate = new Date();
  fromDate.setDate(fromDate.getDate() - 365);
  let fromDateEpoch = moment(fromDate)
  let toDateEpoch = moment(toDate)

  useEffect(() => {
    let userRole = localStorage.getItem('accountType')
    let appUserRolesList = ['Both', 'Buyer', 'Seller']
    if (userRole !== 'Admin') {
      if (appUserRolesList.includes(userRole)) history.push('/dashboard')
      else history.push('/sign-in')
      window.location.reload();
    }
    fetchPendingClaims(pageNumberPendingClaim, searchText);
  }, []);

  const fetchPendingClaims = async (pageNumber, search) => {
    let response = '';
    response = await dispatch(adminClaimList(fromDateEpoch.valueOf(), toDateEpoch.valueOf(), pageNumber, search));
    if (response.status === 'SUCCESS') {
      let adminClaimDataList = response.payload.claimList?.content || []
      setPendingClaimsDataList(adminClaimDataList)
      setPagesCountPendingClaim(response.payload.claimList?.totalPages)
      setTotalDataPendingClaim(response.payload.claimList?.totalElements)
    } else {
      if (response.statusCode === 401) {
        localStorage.removeItem('token')
        history.push('/sign-in')
        window.location.reload(false);
      } else {
        setModalContent(response.message || response.data.message || 'Something went wrong, please try again')
        setModal(!modal)
      }
    }
  }

  const fetchResolvedClaims = async (pageNumber, search) => {
    let response = '';
    response = await dispatch(adminResolvedClaimList(fromDateEpoch.valueOf(), toDateEpoch.valueOf(), pageNumber, search));
    if (response.status === 'SUCCESS') {
      let adminClaimDataList = response.payload.claimList?.content || []
      setResolvedClaimsDataList(adminClaimDataList)
      setPagesCountResolvedClaim(response.payload.claimList?.totalPages)
      setTotalDataResolvedClaim(response.payload.claimList?.totalElements)
    } else {
      if (response.statusCode === 401) {
        localStorage.removeItem('token')
        history.push('/sign-in')
        window.location.reload(false);
      } else {
        setModalContent(response.message || response.data?.message || 'Something went wrong, please try again')
        setModal(!modal)
      }
    }
  };

  const fetchComOrderForRefund = async (pageNumber, search) => {
    let response = '';
    response = await dispatch(adminCompletedOrderListforRefund(fromDateEpoch.valueOf(), toDateEpoch.valueOf(), pageNumber, search));
    if (response.status === 'SUCCESS') {
      let adminClaimDataList = response.payload.orderList?.content || []
      setRefundTabDataList(adminClaimDataList)
      setPagesCountRefundTab(response.payload.orderList?.totalPages)
      setTotalDataRefundTab(response.payload.orderList?.totalElements)
    } else {
      if (response.statusCode === 401) {
        localStorage.removeItem('token')
        history.push('/sign-in')
        window.location.reload(false);
      } else {
        setModalContent(response.message || response.data?.message || 'Something went wrong, please try again')
        setModal(!modal)
      }
    }
  };

  const fetchRefundCompletedTransactions = async (pageNumber, search) => {
    let response = '';
    response = await dispatch(adminRefundCompletedTrans(fromDateEpoch.valueOf(), toDateEpoch.valueOf(), pageNumber, search));
    if (response.status === 'SUCCESS') {
      let adminClaimDataList = response.payload.adjustmentDTOList?.content || []
      setRefundedTransactionsTabDataList(adminClaimDataList)
      setPagesCountRefundedTransTab(response.payload.adjustmentDTOList?.totalPages)
      setTotalDataRefundedTransTab(response.payload.adjustmentDTOList?.totalElements)
    } else {
      if (response.statusCode === 401) {
        localStorage.removeItem('token')
        history.push('/sign-in')
        window.location.reload(false);
      } else {
        setModalContent(response.message || response.data?.message || 'Something went wrong, please try again')
        setModal(!modal)
      }
    }
  };

  const changeTab = e => {
    let currentTab = e.target.id
    setSelectedTab(currentTab)
    setSearchText('')
    setExpandPanel()
    setExpandPanelRefund()
    if (currentTab === 'pendingClaims') fetchPendingClaims(pageNumberPendingClaim, '')
    else if (currentTab === 'resolvedClaims') fetchResolvedClaims(pageNumberResolvedClaim, '')
    else if (currentTab === 'refundClaims') fetchComOrderForRefund(pageNumberRefundTab, '')
    else if (currentTab === 'refundTransclaims') fetchRefundCompletedTransactions(pageNumberRefundedTransTab, '')
  }

  const setResolutionModal = resolutionType => {
    let modalLists = ['exchangePopUp', 'issueCreditPopUp', 'ptOverridePopUp', 'noActionPopUp']
    if (modalLists.includes(resolutionType)) setClaimResolutionModal(true)
    else setClaimResolutionConfirmationModal(true)
    setClaimResolutionType(resolutionType)
  }

  const resolveClaimFunction = async () => {
    const token = localStorage.getItem('token');
    let values = resolvePayload
    let discountAmountValue = 0
    let data = {
      claimStatus: "ADMIN_RESOLVED",
      claimId: clickedOrderDetails?.claimId,
      orderId: clickedOrderDetails?.orderId,
      discountAmount: discountAmountValue
    }
    if (values) {
      data.comment = values?.comments
      if (values.fixedAmount !== '') data.discountAmount = parseFloat(values.fixedAmount)
      if (values.adminClaimQuality !== '') data.totalPalletQuality = parseFloat(values.adminClaimQuality)
      if (values.adminClaimQuantity !== '') data.totalPalletQuantity = parseFloat(values.adminClaimQuantity)
    }

    if (claimResolutionType === 'exchangePopUp') {
      data.resolutionType = "EXCHANGE"
      data.returnPickUpDate = moment(values?.exchangeDate).format("YYYY-MM-DD")
    } else if (claimResolutionType === 'issueCreditPopUp') {
      data.resolutionType = "CREDIT"
    } else if (claimResolutionType === 'assignBackPopUp') {
      data.resolutionType = "ASSIGNED_BACK"
      data.comment = "Assigned back to seller"
    } else if (claimResolutionType === 'noActionPopUp') {
      data.resolutionType = "NOACTION"
    } else if (claimResolutionType === 'ptOverridePopUp') {
      data.resolutionType = "PT_DISCOUNT"
    }
    let response = await dispatch(adminClaimResolve(data, token));
    setClaimResolutionConfirmationModal(false)
    setClaimResolutionModal(false)
    setExpandPanel()
    setResolvePayload()
    if (response.status === 'SUCCESS') {
      setModalContent(response.message)
      setModal(!modal)
      fetchPendingClaims(pageNumberPendingClaim, searchText)
    } else {
      if (response.statusCode === 401) {
        history.push('./sign-in')
        window.location.reload(false);
      } else {
        setModalContent(response?.data?.error?.message || response?.data?.message || response?.message || 'Something went wrong, please try again in some time.');
        setModal(!modal)
      }
    }
  }

  const resolveRefundFunction = async () => {
    const token = localStorage.getItem('token');
    let data
    if (refundProcessType === 'reverseSellerPayout') {
      data = {
        orderId: clickedOrderDetails?.orderId,
      }
    } else {
      let values = resolvePayload
      let refundAmount = parseFloat(values.ammendedQuantity) * clickedOrderDetails.orderDetails?.pricePerPallet

      if (refundProcessType === 'refundTaxModal') {
        refundAmount = Number(resolvePayload?.taxAmount?.toString()?.replace(/,/g, ''))?.toFixed(2);
      }

      let adjTypeValue
      if (refundProcessType === 'adjustmentPTOveride') adjTypeValue = "PT_AC"
      else if (refundProcessType === 'refundTaxModal') adjTypeValue = 'REFUND_TAX'
      else if (values.adjustmentOptions === 'refundBuyer') adjTypeValue = "SELLER_AC"
      else if (values.adjustmentOptions === 'chargeBuyer') adjTypeValue = 'BUYER_AC'

      let adjQtyVal
      if (refundProcessType === 'refundTaxModal') adjQtyVal = 0
      else adjQtyVal = parseFloat(values.ammendedQuantity)
      
      data = {
        orderId: clickedOrderDetails?.orderId,
        adjQty: adjQtyVal,
        adjAmount: refundAmount,
        adjType: adjTypeValue,
        comments: values.comments
      }
    }

    let response
    if (refundProcessType === 'reverseSellerPayout') {
      response = await dispatch(reverseSellerPayoutApi(data, token));
    } else {
      response = await dispatch(adminRefundResolve(data, token));
    }
    setRefundConfirmationModal(false)
    setRefundAdjustmentModal(false)
    setExpandPanel()
    setExpandPanelRefund()
    setResolvePayload()
    if (response.status === 'SUCCESS') {
      setModalContent(response.message)
      setModal(!modal)
      fetchComOrderForRefund(pageNumberRefundTab, searchText)
    } else {
      if (response.statusCode === 401) {
        history.push('./sign-in')
        window.location.reload(false);
      } else {
        setModalContent(response?.data?.error?.message || response?.data?.message || response?.message || 'Something went wrong, please try again in some time.');
        setModal(!modal)
      }
    }
  }

  //handle page change
  const handlePageChange = (value, type) => {
    scrollTop()
    setExpandPanel()
    setExpandPanelRefund()
    if (type === 'pending') {
      setPageNumberPendingClaim(value)
      fetchPendingClaims(value, searchText);
    } else if (type === 'resolved') {
      setPageNumberResolvedClaim(value)
      fetchResolvedClaims(value, searchText)
    } else if (type === 'refund') {
      setPageNumberRefundTab(value)
      fetchComOrderForRefund(value, searchText)
    } else if (type === 'refundComTrans') {
      setPageNumberRefundedTransTab(value)
      fetchRefundCompletedTransactions(value, searchText)
    }
  };

  //handle search change
  const handleSearchChange = (e) => {
    let search = e.target.value
    setSearchText(search)
    setExpandPanel()
    setExpandPanelRefund()
    if (selectedTab === 'pendingClaims') {
      setPageNumberPendingClaim(1)
      handleDebounceSearchPending(search);
    } else if (selectedTab === 'resolvedClaims') {
      setPageNumberResolvedClaim(1)
      handleDebounceSearchResolved(search);
    } else if (selectedTab === 'refundClaims') {
      setPageNumberRefundTab(1)
      handleDebounceSearchRefundTab(search);
    } else if (selectedTab === 'refundTransclaims') {
      setPageNumberRefundedTransTab(1)
      handleDebounceSearchRefundedTransTab(search);
    }
  };
  const handleDebounceSearchPending = useCallback(debounce((value) => fetchPendingClaims(1, value), 500), []);
  const handleDebounceSearchResolved = useCallback(debounce((value) => fetchResolvedClaims(1, value), 500), []);
  const handleDebounceSearchRefundTab = useCallback(debounce((value) => fetchComOrderForRefund(1, value), 500), []);
  const handleDebounceSearchRefundedTransTab = useCallback(debounce((value) => fetchRefundCompletedTransactions(1, value), 500), []);

  return (
    <ClaimContainer>
      {(adminRoles && (adminRoles.includes('SUPER_ADMIN') || adminRoles.includes('RESOLUTION_CENTER_ADMIN'))) ?
        <>
          {loaderVisible && <Spinner />}
          <TableWrapper>
            <Heading>
              <h3>Resolution Center </h3>
              <SearchWrapper>
                <input type="text" placeholder='Search' value={searchText} onChange={handleSearchChange} />
                <AiOutlineSearch />
              </SearchWrapper>
            </Heading>
            <div className='admin-claim-subheading'>
              <p className={selectedTab === 'pendingClaims' && 'selected'} id='pendingClaims' onClick={changeTab}>Claims</p>
              <p className={selectedTab === 'resolvedClaims' && 'selected'} id='resolvedClaims' onClick={changeTab}>Resolved Claims</p>
              <p className={selectedTab === 'refundClaims' && 'selected'} id='refundClaims' onClick={changeTab}>Refunds</p>
              <p className={selectedTab === 'refundTransclaims' && 'selected'} id='refundTransclaims' onClick={changeTab}>Refund Transactions</p>
            </div>
          </TableWrapper>
          {selectedTab === 'pendingClaims' &&
            <ClaimDetails
              claimsDataList={pendingClaimsDataList}
              tabType='pendingClaims'
              expandPanel={expandPanel}
              setExpandPanelFunc={(index) => setExpandPanel(index)}
              setResolutionModal={setResolutionModal}
              pageNumber={pageNumberPendingClaim}
              totalPagesCount={pagesCountPendingClaim}
              onPageChange={val => handlePageChange(val, 'pending')}
              setClickedOrderDetailsFunc={val => setClickedOrderDetails(val)}
            />}
          {selectedTab === 'resolvedClaims' &&
            <ClaimDetails
              claimsDataList={resolvedClaimsDataList}
              tabType='resolvedClaims'
              expandPanel={expandPanel}
              setExpandPanelFunc={(index) => setExpandPanel(index)}
              pageNumber={pageNumberResolvedClaim}
              totalPagesCount={pagesCountResolvedClaim}
              onPageChange={val => handlePageChange(val, 'resolved')}
            />}
          {selectedTab === 'refundClaims' &&
            <Refunds
              claimsDataList={refundTabDataList}
              tabType='refundClaims'
              expandPanel={expandPanelRefund}
              setExpandPanelFunc={(index) => setExpandPanelRefund(index)}
              pageNumber={pageNumberRefundTab}
              totalPagesCount={pagesCountRefundTab}
              onPageChange={val => handlePageChange(val, 'refund')}
              setRefundAdjustModal={(val, clickedOrderItem, type) => {
                if (type === 'refundTaxModal' && clickedOrderItem.buyerInfo.price.tax <= 0) {
                  setModalContent('Since tax amount is $0, it cannot be refunded.')
                  setModal(!modal)
                } else if (type === 'reverseSellerPayout') {
                  setRefundProcessType(type)
                  setClickedOrderDetails(clickedOrderItem)
                  setRefundConfirmationModal(true)
                } else {
                  setRefundAdjustmentModal(val)
                  setRefundProcessType(type)
                  setClickedOrderDetails(clickedOrderItem)
                }
              }}
            />}
          {selectedTab === 'refundTransclaims' &&
            <Refunds
              claimsDataList={refundedTransactionsTabDataList}
              tabType='refundTransclaims'
              expandPanel={expandPanelRefund}
              setExpandPanelFunc={(index) => setExpandPanelRefund(index)}
              pageNumber={pageNumberRefundedTransTab}
              totalPagesCount={pagesCountRefundedTransTab}
              onPageChange={val => handlePageChange(val, 'refundComTrans')}
            />}
          <AlertModal
            isOpen={modal}
            toggle={() => setModal(!modal)}
            title=''
            content={modalContent}
          />
        </>
        :
        <p>You are not authorized to view this page.</p>
      }
      <Modal isOpen={claimResolutionModal} centered={true} size='lg'>
        <ClaimResolutioHeader>
          <ModalBody>
            <ResolutionModal
              toggle={() => setClaimResolutionModal(!claimResolutionModal)}
              claimResolutionType={claimResolutionType}
              claimDetails={clickedOrderDetails}
              resolveClaimFunctionCallBack={val => {
                setResolvePayload(val)
                setClaimResolutionModal(false)
                setClaimResolutionConfirmationModal(true)
              }} />
          </ModalBody>
        </ClaimResolutioHeader>
      </Modal>
      <Modal isOpen={claimResolutionConfirmationModal} centered={true}>
        <ClaimResolutioHeader>
          <ModalBody>
            {loaderVisible && <Spinner />}
            <ResolutionModalInnerBoxes>
              <div className={"exchange-modal-header"}>
                {claimResolutionType === 'exchangePopUp' && <h1>Exchange Damaged or Supply Missing</h1>}
                {claimResolutionType === 'issueCreditPopUp' && <h1>Issue Credit for Missing or Damaged</h1>}
                {claimResolutionType === 'assignBackPopUp' && <h1>Assign Back to Seller</h1>}
                {claimResolutionType === 'noActionPopUp' && <h1>No Action</h1>}
                {claimResolutionType === 'ptOverridePopUp' && <h1>PT Override</h1>}
                <img src={CloseIcon} alt="close-icon" onClick={() => setClaimResolutionConfirmationModal(false)} />
              </div>
            </ResolutionModalInnerBoxes>
            <div className='confirmation-content'>
              {claimResolutionType === 'exchangePopUp' && <p>Are you sure you want to create exchange order for total Quantity {((resolvePayload?.adminClaimQuality !== '' && parseFloat(resolvePayload?.adminClaimQuality)) + (resolvePayload?.adminClaimQuantity !== '' && parseFloat(resolvePayload?.adminClaimQuantity)))}?</p>}
              {claimResolutionType === 'issueCreditPopUp' && <p>Are you sure you want to issue credit to buyer for total amount of ${resolvePayload?.fixedAmount?.toFixed(2)}?</p>}
              {claimResolutionType === 'assignBackPopUp' && <p>Are you sure you want to assign back?</p>}
              {claimResolutionType === 'noActionPopUp' && <p>Are you sure you don’t want to take any action?</p>}
              {claimResolutionType === 'ptOverridePopUp' && <p>Are you sure you want to issue credit to buyer for total amount of ${resolvePayload?.fixedAmount?.toFixed(2)} from PT account?</p>}
              <div>
                <button onClick={() => setClaimResolutionConfirmationModal(false)} className='no-button'>No</button>
                <button className='yes-button' onClick={resolveClaimFunction}>Yes</button>
              </div>
            </div>
          </ModalBody>
        </ClaimResolutioHeader>
      </Modal>
      <Modal isOpen={refundAdjustmentModal} centered={true} size={refundProcessType !== 'refundTaxModal' && 'lg'}>
        <ClaimResolutioHeader>
          <ModalBody>
            <AdjustmentModal
              toggle={() => setRefundAdjustmentModal(!refundAdjustmentModal)}
              selectedOrderDetails={clickedOrderDetails}
              refundProcessType={refundProcessType}
              refundClaimFunctionCallBack={val => {
                setResolvePayload(val)
                setClaimResolutionModal(false)
                setRefundConfirmationModal(true)
              }} />
          </ModalBody>
        </ClaimResolutioHeader>
      </Modal>
      <Modal isOpen={refundConfirmationModal} centered={true}>
        <ClaimResolutioHeader>
          <ModalBody>
            {loaderVisible && <Spinner />}
            <ResolutionModalInnerBoxes>
              <div className={"exchange-modal-header"}>
                {refundProcessType === 'adjustmentModal' && <h1>Payment Adjustment</h1>}
                {refundProcessType === 'adjustmentPTOveride' && <h1>Payment Adjustment - PT Override</h1>}
                {refundProcessType === 'refundTaxModal' && <h1>Tax Refund</h1>}
                {refundProcessType === 'reverseSellerPayout' && <h1>Reverse Seller Payout</h1>}
                <img src={CloseIcon} alt="close-icon" onClick={() => setRefundConfirmationModal(false)} />
              </div>
            </ResolutionModalInnerBoxes>
            <div className='confirmation-content'>
              {refundProcessType === 'adjustmentModal' && <p>
                {resolvePayload?.adjustmentOptions === 'refundBuyer' ?
                  `Are you sure you want to refund $${resolvePayload?.adjustmnetValues?.totalBuyerPrice?.toFixed(2)} to the buyer?` :
                  `Are you sure you want to charge the buyer $${resolvePayload?.adjustmnetValues?.totalBuyerPrice?.toFixed(2)}?`}</p>}
              {refundProcessType === 'adjustmentPTOveride' && <p>Are you sure you want to refund ${resolvePayload?.adjustmnetValues?.totalBuyerPrice?.toFixed(2)} to the buyer ?</p>}
              {refundProcessType === 'refundTaxModal' && resolvePayload?.taxAmount != null && (
                <p>Are you sure you want to refund tax of ${Number(resolvePayload.taxAmount.toString().replace(/,/g, '')).toFixed(2)}?</p>
              )}
              {refundProcessType === 'reverseSellerPayout' && <p>Are you sure want to withdraw the payment from seller account ?</p>}
              <div>
                <button onClick={() => setRefundConfirmationModal(false)} className='no-button'>No</button>
                <button className='yes-button' onClick={resolveRefundFunction}>Yes</button>
              </div>
            </div>
          </ModalBody>
        </ClaimResolutioHeader>
      </Modal>
    </ClaimContainer>
  )
}

export default Claim